import { useCoiOnFile } from "../api";
import { formatDate, formatMoneyCents } from "../format";

// Phase 4a customer-portal FR-9 (COI on file tab). Read-only — the
// upload flow lives in the existing 2b CoiPage at /account/coi.
export function CoiTab(): JSX.Element {
  const q = useCoiOnFile();
  if (q.isLoading) return <div className="text-sm text-zinc-600">Loading…</div>;
  if (!q.data) return <div className="text-sm text-red-700">Couldn&rsquo;t load COI.</div>;

  const coi = q.data.current;
  if (coi == null) {
    return (
      <div className="rounded border border-amber-300 bg-amber-50 p-3 text-sm" data-testid="coi-missing">
        No COI on file. Upload one from the COI page before your next rental.
        <div className="mt-2">
          <a href="/account/coi" className="underline">
            Go to COI upload
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2 text-sm">
      {coi.expired ? (
        <div className="rounded border border-red-600 bg-red-50 p-3" data-testid="coi-expired">
          <strong>Expired — upload a new COI before your next rental.</strong>
        </div>
      ) : null}
      <div className="rounded border border-zinc-200 p-3 space-y-1">
        <div>
          <strong>{coi.insurer ?? "Insurer"}</strong>
        </div>
        {coi.policy_number ? <div className="text-xs">Policy #{coi.policy_number}</div> : null}
        {coi.gl_limit_cents != null ? (
          <div className="text-xs">GL limit {formatMoneyCents(coi.gl_limit_cents)}</div>
        ) : null}
        {coi.expiry_date ? <div className="text-xs">Expires {formatDate(coi.expiry_date)}</div> : null}
        <div className="text-xs text-zinc-500">{coi.status}</div>
        <a href={coi.pdf_url} className="text-xs underline" target="_blank" rel="noreferrer">
          Download PDF
        </a>
      </div>
    </div>
  );
}
